import { micrositesMetadataListForTests } from './constants'
import { CMS_MICROSITE_MESSAGE, CMS_MICROSITE_MESSAGE_KEY } from './messages/messages'
import { CMS_MICROSITE_ID, CMSMicrositeMetadata, CMSMicrositePostMessageEvent } from './types'
import { API_REQUEST_HEADERS } from '../common/constants/requestHeaderConstants'
import { getGoodnessBaseUrl } from '../common/utils/commonUtils'
import { CustomPathwayOption } from '../pathways/constants'

export const getMicrositeUrl = (
  url: string,
  isLibraryEventsDisabled: boolean,
  displayLanguage?: string,
  theme?: string,
  isFreshpaintEnabled?: boolean,
) => {
  const micrositeUrl = `${getGoodnessBaseUrl(displayLanguage)}${url}`
  const params = new URLSearchParams()
  if (isLibraryEventsDisabled) {
    params.set('x-disabled-work-hub-events', 'true')
  }
  if (theme) {
    params.set(API_REQUEST_HEADERS.X_LYRA_THEME, theme)
  }
  if (isFreshpaintEnabled) {
    params.set(API_REQUEST_HEADERS.X_FRESHPAINT_ENABLED, 'true')
  }
  const queryString = params.toString()
  return queryString ? `${micrositeUrl}?${queryString}` : micrositeUrl
}

export const getMicrositePathwayKey = (
  micrositeId: CMS_MICROSITE_ID,
  messageKey: CMS_MICROSITE_MESSAGE,
  eventKey?: string,
): CustomPathwayOption => {
  const capitalizedMessageKey = `${messageKey.charAt(0).toUpperCase()}${messageKey.slice(1)}`
  const eventSuffix = eventKey
    ? eventKey
        .split('-')
        .map((segment) => `${segment.charAt(0).toUpperCase()}${segment.slice(1)}`)
        .join('')
    : ''
  return `CustomPathway${micrositeId}${capitalizedMessageKey}${eventSuffix}`
}

/**
 * Selects the metadata entry a post message refers to. Without an `eventKey` the first entry wins,
 * which is how single-event microsites and any CMS that doesn't send an `eventKey` keep working.
 */
export const resolvePostMessageEvent = (
  entries: CMSMicrositePostMessageEvent[],
  eventKey?: string,
): CMSMicrositePostMessageEvent | undefined =>
  eventKey === undefined ? entries[0] : entries.find((entry) => entry.params?.eventKey === eventKey)

export const getWebinarLink = (micrositeMetadata: CMSMicrositeMetadata, eventKey?: string) => {
  const webinarEvents = micrositeMetadata.postMessageEvents.filter(
    (item) => item.key === CMS_MICROSITE_MESSAGE_KEY.REGISTER_WEBINAR,
  )
  return resolvePostMessageEvent(webinarEvents, eventKey)?.params?.webinarLink
}

/** For tests, when it doesn't matter which microsite we use, return the first one in our list */
export const getMicrositeFromList = () => {
  if (micrositesMetadataListForTests.length < 1) {
    return null
  }
  return micrositesMetadataListForTests[0]
}
